import React, { useEffect, useState } from "react";
import "./i18n";
import Body from "./Body";
import Navbar from "./Components/Navbar/Navbar";
import TouristTaxBanner from "./TouristTaxBanner";
import About from "./About";
import Features from "./Features";
import HomeFleetCarousel from "./HomeFleetCarousel";
import LatestBlogPost from "./LatestBlogPost";
import { Box, CircularProgress, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const App = () => {
  const [choosedCar, setChoosedCar] = useState({
    brand: null,
    code: null,
    picture: null,
    pictureSource: null,
  });
  const [reservationModalOpen, setReservationModalOpen] = useState(false);
  const [appLoading, setAppLoading] = useState(true);

  useEffect(() => {
    const hide = () => setAppLoading(false);
    if (document.readyState === "complete") {
      hide();
    } else {
      window.addEventListener("load", hide);
      return () => window.removeEventListener("load", hide);
    }
  }, []);

  const onReserveClick = (car) => {
    setChoosedCar(car);
    setReservationModalOpen(true);
  };

  return (
    <>
      {appLoading && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(230, 230, 230, 0.95)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={60} thickness={3} sx={{ color: "#1C2541" }} />
        </Box>
      )}

      <Navbar />

      <Dialog
        open={reservationModalOpen}
        onClose={() => setReservationModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <IconButton
          onClick={() => setReservationModalOpen(false)}
          sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>
        <Body
          choosedCar={choosedCar}
          setChoosedCar={setChoosedCar}
          isModal
        />
      </Dialog>

      {/* Hero — reservation form */}
      <TouristTaxBanner />
      <Body choosedCar={choosedCar} setChoosedCar={setChoosedCar} />

      {/* About banner */}
      <About />

      {/* How We Work */}
      <Features />

      {/* Fleet carousel */}
      <HomeFleetCarousel onReserveClick={onReserveClick} />

      {/* Latest blog article */}
      <LatestBlogPost />
    </>
  );
};

export default App;
